export const ManageTypesConstants = {
  addManageTypes: 'Add Manage Types',
  addType: 'Add Type',
  deleteType: 'Delete type',
  invoiceLineItem: 'Invoice Line Item',
  paymentLineItem: 'Payment Line Item',
  thisIsDeduction: 'This item is a deduction',
  unit: 'Unit',
};
